var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inte-raffle"},[_c('LuckyWheel',{ref:"myLucky",staticClass:"zp-box",attrs:{"width":"478px","height":"443px","prizes":_vm.prizeList,"blocks":_vm.blocks,"buttons":_vm.buttons},on:{"start":_vm.startCallback,"end":_vm.endCallback}}),_c('div',{staticClass:"tips"},[_vm._v(" "+_vm._s(_vm.goldNum)+"积分/次 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }